import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { buildUsdCashoutDraft } from '../cashout-draft-builders';
import { CashoutDraft } from '../cashout-currency.types';
import {
  setUsdFuseBeneficiaryType,
  setupUsdCashoutForm,
  updateUsdFusePayoutValidators,
  USD_FUSE_PAYOUT_PURPOSE_OPTIONS,
} from './usd-form.logic';

@Component({
  selector: 'app-usd-form',
  templateUrl: './usd-form.component.html',
  styleUrl: '../../add-cashout.component.scss',
})
export class UsdFormComponent implements OnInit {
  @Input() ctx!: any;
  @Output() draftReady = new EventEmitter<CashoutDraft>();

  readonly fusePayoutPurposeOptions = USD_FUSE_PAYOUT_PURPOSE_OPTIONS;

  ngOnInit(): void {
    setupUsdCashoutForm(this.ctx);
  }

  setFuseBeneficiaryType(type: 'individual' | 'corporate'): void {
    setUsdFuseBeneficiaryType(this.ctx, type);
  }

  onFuseRailChange(): void {
    updateUsdFusePayoutValidators(this.ctx);
  }

  saveTransaction(): void {
    const draft = buildUsdCashoutDraft(this.ctx);
    if (draft) {
      this.draftReady.emit(draft);
    }
  }
}
